export default {
    list : [
        {"goodsId":"JM05","sendNum":"1","amt":"100000"},
        {"goodsId":"AG37","sendNum":"1","amt":"1000"},
        {"goodsId":"X230","sendNum":"100","amt":"1000"},
        {"goodsId":"X230","sendNum":"200","amt":"2000"},
        {"goodsId":"KG74","sendNum":"20","amt":"2000"},
        {"goodsId":"MS86","sendNum":"50","amt":"5000"},
        {"goodsId":"OT41","sendNum":"40","amt":"12000"},
        {"goodsId":"F418","sendNum":"200","amt":"4000"},
        {"goodsId":"AM53","sendNum":"2","amt":"10000"},
        {"goodsId":"AM52","sendNum":"2","amt":"13000"},
        {"goodsId":"KF93","sendNum":"10","amt":"2500"},
        {"goodsId":"AG00","sendNum":"1","amt":"1000"},
        {"goodsId":"AG00","sendNum":"2","amt":"2000"},
        {"goodsId":"X472","sendNum":"100","amt":"5000"},
        {"goodsId":"X472","sendNum":"200","amt":"10000"}
    ]
}